import { EnvironmentProviders, isDevMode } from '@angular/core';
import { provideStore } from '@ngxs/store';
import { ConnectionState } from './connection.store';
import { DriversState } from './drivers.store';
import { OrdersState } from './orders.store';
import { ReferenceDataState } from './reference-data.store';
import { SessionState } from './session.store';
import { ShuttleState } from './shuttle.store';

export const APP_STATE_CLASSES = [
  SessionState,
  ReferenceDataState,
  OrdersState,
  DriversState,
  ConnectionState,
  ShuttleState
] as const;

export function provideAppStore(): EnvironmentProviders {
  return provideStore([...APP_STATE_CLASSES], {
    developmentMode: isDevMode()
  });
}
